var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFundraisingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953",
    transform: "translate(1681 18627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935",
    transform: "translate(-1972 -18776)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(291 149)",
    fill: "#18beb3",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936",
    transform: "translate(-1699.597 -18647.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M50.92,324.347a1.66,1.66,0,0,0-2.232-.74l-2.227,1.121a1.513,1.513,0,0,0-1.321-1.1l-1.836-.163a3.163,3.163,0,0,1-1.016-.273l-1.873-.992a4.993,4.993,0,0,0-2.427-.461,8.817,8.817,0,0,0-4.082,1.253,8.851,8.851,0,0,1-1.328.693v-.109a.433.433,0,0,0-.433-.432H27.381a.433.433,0,0,0-.433.432v5.967a.433.433,0,0,0,.433.433h4.765a.433.433,0,0,0,.433-.433v-.483a9.488,9.488,0,0,1,1.942.129l5.045.684,3.3.267a1.624,1.624,0,0,0,.268.022,1.663,1.663,0,0,0,.792-.2l6.3-3.413A1.655,1.655,0,0,0,50.92,324.347Zm-19.206,4.764h-3.9v-5.1h3.9Zm18.1-3.321L43.508,329.2a.845.845,0,0,1-.542.081l-3.308-.269-5.009-.68a10.146,10.146,0,0,0-2.071-.14V324.62a9.506,9.506,0,0,0,1.8-.9,7.942,7.942,0,0,1,3.669-1.118,4.149,4.149,0,0,1,1.986.372l1.873.992a4.063,4.063,0,0,0,1.321.36l1.839.163a.673.673,0,0,1-.06,1.344H41.058a.433.433,0,1,0,0,.865H45a1.538,1.538,0,0,0,1.433-.989l2.64-1.33a.8.8,0,0,1,.737,1.41Z",
    transform: "translate(0 -276.106)",
    fill: "#18beb3",
    stroke: "#18beb3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M83.7,375.251h.474a.3.3,0,0,0,.3-.3v-1.058a.3.3,0,0,0-.3-.3H83.7a.3.3,0,0,0-.3.3v1.058A.3.3,0,0,0,83.7,375.251Z",
    transform: "translate(-53.472 -325.235)",
    fill: "#18beb3",
    stroke: "#18beb3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M262.8,44.681a1.448,1.448,0,0,0,.736.256l3.388.223v-.008c.047,0,.093.016.141.017h.072a2.73,2.73,0,0,0,1.894-.849c1.313-1.272,2.128-3.8,2.128-6.606s-.815-5.335-2.128-6.607a2.665,2.665,0,0,0-1.963-.847h0l-2.988.07a2.3,2.3,0,0,0-1.207.369c-1.566,1.028-2.618,3.847-2.618,7.015S261.251,43.6,262.8,44.681Zm.793-.607a.589.589,0,0,1-.3-.1,2.947,2.947,0,0,1-.538-.511l1.81.015a5.113,5.113,0,0,0,.545.7Zm3.5-12.949h.045a1.865,1.865,0,0,1,1.291.605c1.132,1.1,1.864,3.447,1.864,5.985s-.732,4.887-1.864,5.985a1.8,1.8,0,0,1-1.337.6c-1.688-.052-3.114-3.07-3.114-6.589S265.4,31.178,267.092,31.125Zm-3.749.3a1.44,1.44,0,0,1,.754-.228l1.094-.026a5.246,5.246,0,0,0-.755,1l-1.82-.019A3.094,3.094,0,0,1,263.343,31.423Zm-1.262,1.585,1.911.02a10.448,10.448,0,0,0-.669,2.294l-1.973-.014A9.294,9.294,0,0,1,262.081,33.008Zm-.965,4.706a12.948,12.948,0,0,1,.1-1.542l1.979.014a14.045,14.045,0,0,0-.083,1.528c0,.423.023.835.058,1.237l-1.991-.015C261.142,38.536,261.116,38.129,261.116,37.714Zm.172,2.088,1.986.015a10.406,10.406,0,0,0,.816,2.789l-1.907-.016A9.251,9.251,0,0,1,261.288,39.8Z",
    transform: "translate(-221.004 0)",
    fill: "#18beb3",
    stroke: "#18beb3",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundraisingIcon);
export default __webpack_public_path__ + "static/media/fundraising-icon.cf55f060f85edcb614b23214e52b8093.svg";
export { ForwardRef as ReactComponent };